import React from 'react';
import * as ReactDOM from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import {TranslationProvider} from './context/translationContext';
import App from './App';
import './index.css';

const rootElement : HTMLElement | null = document.querySelector('[data-nezzocareermodel-careermodel]');

if (rootElement !== null) {

    const root = ReactDOM.createRoot(rootElement);
    const translationScriptTag = document.querySelector('[data-nezzocareermodel-translation]');
    const translations = JSON.parse(translationScriptTag ? translationScriptTag.innerHTML : '[]');

    root.render(
        <React.StrictMode>
            <BrowserRouter>
                <TranslationProvider value={translations}>
                    <App/>
                </TranslationProvider>
            </BrowserRouter>
        </React.StrictMode>
    );

}
